import React, { useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Button from "src/components/app/Button";
import Header from "src/components/app/layout/Header";
import Layout from "src/components/app/layout/Layout";
import ScheduleScreen from "src/components/app/schedule/ScheduleScreen";

const ScheduleLabTest: React.FC = () => {
  const params = useParams();
  const supportProgramKey = params["support-program-key"];
  const navigate = useNavigate();
  const [selectedDate, setSelectedDate] = useState<Date | null>(new Date());
  const [selectedTimeSlot, setSelectedTimeSlot] = useState<string | null>(null);
  const [selectedTimeSlotId, setSelectedTimeSlotId] = useState<string | null>(
    null
  );
  const location = useLocation();
  const address = location.state?.address;
  const patient = location.state?.patient;
  const rescheduleReason = location.state?.rescheduleReason;
  const orderDetails = location.state?.orderDetails;
  console.log("address in schedule lab test", address);
  const handleDateTimeChange = (
    date: Date | null,
    time: string | null,
    slotId: string | null = null
  ) => {
    setSelectedDate(date);
    setSelectedTimeSlot(time);
    setSelectedTimeSlotId(slotId);
  };

  console.log("location state in schedule lab test", location.state);
  const navigateToLabTestSummary = () => {
    if (rescheduleReason && orderDetails) {
      navigate(`/app/${supportProgramKey}/book-lab-test/reschedule-summary`, {
        state: {
          orderDetails,
          rescheduleReason,
          address,
          patient,
          selectedDate,
          selectedTimeSlot,
          selectedTimeSlotId,
        },
      });
    } else {
      navigate(`/app/${supportProgramKey}/book-lab-test/summary`, {
        state: {
          selectedDate,
          selectedTimeSlot,
          selectedTimeSlotId,
          patient,
          address,
        },
      });
    }
  };

  return (
    <Layout supportProgramKey={supportProgramKey || ""}>
      {/* Header */}
      <div className="flex flex-col h-full">
        <Header
          title="Select Test Slot"
          onBackClick={() => {
            if (rescheduleReason && orderDetails) {
              navigate(`/app/${supportProgramKey}/book-lab-test/order-history`);
            } else {
              navigate(`/app/${supportProgramKey}/book-lab-test/checkout`);
            }
          }}
        />

        <ScheduleScreen
          onDateTimeChange={handleDateTimeChange}
          screenName="book_lab_test"
          address={address}
        />

        <div>
          <div className="fixed rounded-t-lg max-w-lg mx-auto w-full min-h-20 bg-white bottom-0 left-0 right-0 z-10 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] bg-black/50">
            <div className="flex justify-between items-center p-4">
              <Button
                rounded="full"
                disabled={!selectedDate || !selectedTimeSlot}
                onClick={() => {
                  console.log(
                    "selectedDate and selectedTimeSlot",
                    selectedDate,
                    selectedTimeSlot,
                    selectedTimeSlotId
                  );
                  navigateToLabTestSummary();
                }}
                fullWidth
              >
                Review Details
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ScheduleLabTest;
